import { useParams } from 'react-router-dom'

import { StoreData } from '@/types'

import { useStoresContext } from '../stores/stores-context'

// function to strip 'IKEA ' from the unit name
// and turn the unit name into a lowercase kebab case string
// replace spaces with pluses
// removes slashes and dashes
// example: 'IKEA Amsterdam' -> 'amsterdam'
// example: 'IKEA A Coruña' -> 'a+coruña'
// example: 'IKEA Barakaldo / IKEA Pamplona' -> 'barakaldo,pamplona'

export function storeNameToUrlParam(name: string) {
  const encoded = name
    .toLowerCase()
    .replace(/ikea /gi, '')
    .trim()
    .replace(/\//g, '')
    .replace(/-/g, '')
    .replace(/\s+/gi, '+')
  return encoded
}

// function to map out the store url param to the store data
export function urlParamToStoreData(param: string, stores: StoreData[]) {
  const storeData = stores.find(
    ({ name }) => storeNameToUrlParam(name) === param
  )
  return storeData
}

export function useSelectedStoresFromUrl() {
  const { stores } = useStoresContext()
  const possibleStoreParams = stores
    .map(({ name }) => storeNameToUrlParam(name))
    .join('-')
  const { listOfStores } = useParams()
  // parse the list of stores
  // it's expected to be a kebab case string with store names
  // example: 'amsterdam-rotterdam-utrecht'
  const rawStoresParam = listOfStores?.split('-') ?? []
  // keep only the params that are in the list of possible store params
  const storesParam = rawStoresParam.filter((store) =>
    possibleStoreParams.includes(store)
  )
  // map the store names to the store data
  const selectedStores = storesParam
    .map((store) => urlParamToStoreData(store, stores))
    .filter((data: StoreData | undefined): data is StoreData => !!data)
  // map the data into the store ids
  const selectedStoreIds = selectedStores.map(({ store_id }) => store_id)

  return { selectedStores, selectedStoreIds }
}
